module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tab-pane')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15604642"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tab/rtTabPane.vue
// module id = 1400
// module chunks = 116